<h3 [innerHTML]="contactText.heading"></h3>
<div [innerHTML]="contactText.mainText" class="id37-text2 text-light"></div>
